import React, { useState } from "react";
import {
  IoIosInformationCircle,
  IoIosInformationCircleOutline,
  IoMdClose,
} from "react-icons/io";
import { axios } from "../../../../../../../../Global";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../../../store/userSlice";
import CandidateErrorPopUp from "../../CandidateErrorPopUp";
import { IoEye } from "react-icons/io5";
import { setArrayValues } from "../../candidateListFunctions";
import nodeinstance from "../../../../../../../../nodeInstance";
// import nodeinstance from "../../nodeInstance";

export default function FileUploadPopup_VISA({
  popupState,
  setPopupState,
  setShowErrorPopUp,
  apiUrl,
  setUpdatedCandidates = null,
  setCandidateListData = null,
  setVisaStampedCandidateData,
}) {
  const dispatch = useDispatch();
  const { projectId } = useParams();
  let [allFiles, setAllFiles] = useState([]);
  const [totalFileLength, setTotalFileLength] = useState(0);

  let [validationErrors, setValidationErrors] = useState([]);

  const [submitLoading, setSubmitLoading] = useState(false);

  const [percentage, setPercentage] = useState(1);

  const [fileSizeError, setFileSizeError] = useState(false);

  const [apiValues, setAPIValues] = useState();
  const getData = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `/dashboard/project-candidates-list/${projectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setAPIValues(response.data.data);
        setUpdatedCandidates(response.data.data?.candidates);
        setArrayValues(response.data.data, setCandidateListData);

        // setExcelData(res.data.data);
      }
    } catch (error) {
      console.log("error to be seen in console", error);
    }
  };
  console.log(".......................test case ....", apiValues);
  const bulkUploadHandler = async (responseData) => {
    setSubmitLoading(true);
    const currentPercentage =
      ((totalFileLength - allFiles.length) / totalFileLength) * 100;
    setPercentage(currentPercentage == 0 ? 1 : currentPercentage);
    if (allFiles.length <= 0) {
      setSubmitLoading(false);
      console.log("function completed");
      setPopupState((p) => ({ open: false }));
      if (setUpdatedCandidates) {
        setUpdatedCandidates(responseData?.candidates);
      }
      if (validationErrors.length <= 0) {
        if (setCandidateListData) {
          setArrayValues(responseData, setCandidateListData);
        }
        dispatch(
          setAppError({
            msg: "Documents uploaded successfully.",
            color: "success",
          })
        );
      } else {
        setShowErrorPopUp([...validationErrors]);
      }
      return;
    } else {
      let uploadingFiles = [];
      if (allFiles.length < 10) {
        uploadingFiles = allFiles.slice(0, allFiles.length);
      } else {
        uploadingFiles = allFiles.slice(0, 10);
      }

      try {
        const formData = new FormData();
        for (let i = 0; i < uploadingFiles.length; i++) {
          formData.append("file[]", uploadingFiles[i]);
        }
        console.log("calling api", new Date().toLocaleTimeString());
        const response = await axios.post(
          apiUrl || `/dashboard/project-candidates/file-upload/${projectId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (response.status == 200) {
          if (response.data?.data?.validation_error) {
            // setValidationErrors((prevState) => [
            //   ...prevState,
            //   ...response.data?.data?.validation_error,
            // ]);
            validationErrors.push(...response.data?.data?.validation_error);
          }
          uploadingFiles = [];
          const updatedArray = [...allFiles];
          updatedArray.splice(0, 10);
          allFiles = updatedArray;
          setTimeout(async () => {
            await bulkUploadHandler(response.data?.data);
          }, 5000);
        }
      } catch (error) {
        console.log(error);
        dispatch(
          setAppError({ msg: error?.response?.data?.message || error?.message })
        );
        const validationErrorObj = error?.response?.data?.validation_error;
        if (validationErrorObj) {
          for (let errorText in validationErrorObj)
            validationErrors.push(...validationErrorObj[errorText]);
        }
        setSubmitLoading(false);
        console.log("function completed with error");
        setPopupState((p) => ({ open: false }));
        if (validationErrors.length > 0) {
          setShowErrorPopUp([...validationErrors]);
        }
        return;
      }
    }
  };

  // const bulkUploadHandler = async (responseData) => {
  //   setSubmitLoading(true);
  //   const currentPercentage =
  //     ((totalFileLength - allFiles.length) / totalFileLength) * 100;
  //   setPercentage(currentPercentage == 0 ? 1 : currentPercentage);
  //   if (allFiles.length <= 0) {
  //     setSubmitLoading(false);
  //     console.log("function completed");
  //     setPopupState((p) => ({ open: false }));
  //     if (setUpdatedCandidates) {
  //       setUpdatedCandidates(apiValues?.candidates);
  //     }
  //     if (validationErrors.length <= 0) {
  //       if (setCandidateListData) {
  //         setArrayValues(apiValues, setCandidateListData);
  //       }
  //       dispatch(
  //         setAppError({
  //           msg: "Documents uploaded successfully.",
  //           color: "success",
  //         })
  //       );
  //     } else {
  //       setShowErrorPopUp([...validationErrors]);
  //     }
  //     return;
  //   } else {
  //     let uploadingFiles = [];
  //     if (allFiles.length < 10) {
  //       uploadingFiles = allFiles.slice(0, allFiles.length);
  //     } else {
  //       uploadingFiles = allFiles.slice(0, 10);
  //     }
  //     const NodeToken = localStorage.getItem("nodeToken");
  //     try {
  //       const formData = new FormData();
  //       for (let i = 0; i < uploadingFiles.length; i++) {
  //         formData.append("file[]", uploadingFiles[i]);
  //       }
  //       console.log("calling api", new Date().toLocaleTimeString());
  //       const response = await nodeinstance.post(
  //         `/dashboard/projects/Upload-candidate-files/${projectId}`,
  //         formData,
  //         {
  //           headers: {
  //             "Content-Type": "multipart/form-data",
  //             Authorization: `Bearer ${NodeToken}`,
  //           },
  //         }
  //       );
  //       console.log("tag the response", response);

  //       if (response.status == 200) {
  //         if (response.data?.results?.length > 0) {
  //           // setValidationErrors((prevState) => [
  //           //   ...prevState,
  //           //   ...response.data?.data?.validation_error,
  //           // ]);
  //           validationErrors.push(...response.data?.results);
  //         }

  //         uploadingFiles = [];
  //         const updatedArray = [...allFiles];
  //         updatedArray.splice(0, 10);
  //         allFiles = updatedArray;

  //         setTimeout(async () => {
  //           getData();
  //           await bulkUploadHandler(apiValues);
  //         }, 5000);
  //       }
  //     } catch (error) {
  //       console.log(error);
  //       dispatch(
  //         setAppError({ msg: error?.response?.data?.message || error?.message })
  //       );
  //       const validationErrorObj = error?.response?.data?.validation_error;
  //       if (validationErrorObj) {
  //         for (let errorText in validationErrorObj)
  //           validationErrors.push(...validationErrorObj[errorText]);
  //       }
  //       setSubmitLoading(false);
  //       console.log("function completed with error");
  //       setPopupState((p) => ({ open: false }));
  //       if (validationErrors.length > 0) {
  //         setShowErrorPopUp([...validationErrors]);
  //       }
  //       return;
  //     }
  //   }
  // };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          popupState.open ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-xl w-full h-auto min-h-[10rem] max-h-[35rem] rounded-md bg-white/95 flex  flex-col gap-10 justify-between p-4 relative ">
          <div className="flex justify-between items-start w-full">
            <div>
              <h1 className="text-xl font-semibold">File Upload</h1>
              <h2 className="text-sm">Bulk Upload Employee Documents</h2>
            </div>
            {!submitLoading && (
              <button
                className="text-md font-semibold cursor-pointer"
                onClick={() => {
                  setPopupState((p) => ({ open: false }));
                }}
                disabled={submitLoading}
              >
                <IoMdClose size={"1.2rem"} />
              </button>
            )}
          </div>
          {!submitLoading ? (
            <div className="w-full max-w-sm flex flex-col gap-2 justify-center mx-auto">
              <div className="flex justify-center items-center gap-4">
                <input
                  type="file"
                  className="file-input file-input-bordered"
                  multiple
                  accept=".pdf"
                  onChange={(e) => {
                    const selectedFiles = Array.from(e.target.files);
                    setAllFiles(selectedFiles);
                    setTotalFileLength(selectedFiles.length);
                    setFileSizeError(false); // Reset error
                  }}
                />

                <div className="relative">
                  <div className="peer  w-fit">
                    <button className="flex items-center gap-2 opacity-90  p-2 px-3  rounded-md w-fit text-xs text-center ">
                      <IoIosInformationCircle size={"2rem"} />
                    </button>
                  </div>
                  <div
                    className={
                      "hidden absolute -top-[5.5rem] right-0 transform  max-w-sm w-[15rem] h-auto bg-white shadow-xl rounded-lg p-2 ring-1 ring-slate-400  peer-hover:flex hover:flex flex-col gap-2"
                    }
                  >
                    <h6 className="font-bold text-sm">File Name Format:</h6>
                    <p className="text-xs ">{"> "} EMPID_PASSPORT.PDF</p>
                    <p className="text-xs ">{"> "} EMPID_VISA.PDF</p>
                    <p className="text-xs ">{"> "} EMPID_VACCINE.PDF</p>
                    <p className="text-xs ">{"> "} EMPID_DRIVINGLICENSE.PDF</p>
                    <p className="text-xs ">
                      {">"}EMPID_SIGNED_EMP_CONTRACT.PDF
                    </p>
                    <p className="text-xs ">
                      {"> "} EMPID_SIGNED_ABSENT_POLICY.PDF
                    </p>
                  </div>
                </div>
              </div>
              <p className="text-sm text-blue">
                Fil Size should be lesser than 5 MB.
              </p>
            </div>
          ) : (
            <div className="w-full max-w-md mx-auto">
              <div className="w-full flex justify-between">
                <h2>Uploading Files</h2>
                <h2>{Math.floor(percentage)}%</h2>
              </div>
              <progress className="progress w-full"></progress>
              {fileSizeError && (
                <p className={`text-sm text-red`}>
                  Files having less than 5 Mb will be uploaded.
                </p>
              )}
            </div>
          )}
          <div className={`w-full flex gap-3 ${submitLoading ? "hidden" : ""}`}>
            <button
              className="w-full max-w-xs rounded-md p-2 ring-1 ring-slate-400"
              onClick={() => {
                setPopupState((p) => ({ open: false }));
              }}
              disabled={submitLoading}
            >
              Cancel
            </button>
            <button
              className="w-full max-w-xs rounded-md p-2 bg-red text-white"
              onClick={bulkUploadHandler}
              disabled={submitLoading}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
